export function hideElements(array: Array<HTMLElement>) {
    array.forEach(el => {
        el.classList.add('hidden');
    });
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/hide-elements.ts